import { render, staticRenderFns } from "./dialogExtendInfo.vue?vue&type=template&id=2f916926&"
import script from "./dialogExtendInfo.vue?vue&type=script&lang=js&"
export * from "./dialogExtendInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogExtendInfo.vue?vue&type=style&index=0&id=2f916926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports